import React from "react";
import "./coach-input-box.scss";

import MainInput from "../main-input/main-input";

const coachInputField = ({withBorder = false, ...props}) => {
  return (
    <div className="box-container">
      {props.showPassword !== undefined ? (
        <div className="box-container">
          <MainInput
            placeholder={props.placeholder}
            type={props.showPassword ? "text" : "password"}
            className={
              "coach-input coach-new-input " + 
              (withBorder ? 'with-border ' : '') +
              (props.hasError == "false" || !props.hasError ? "" : "error")
            }
            onChange={props.change}
            onBlur={props.blur}
            value={props.value}
            maxLength="40"
            showborderbottom="true"
          />
          <div className="box-image">
            <img
              src={props.showPassword ? props.dontShowIcon : props.showIcon}
              onClick={props.click}
            />
          </div>
        </div>
      ) : (
        <div className="box-container">
          <MainInput
            placeholder={props.placeholder}
            label={props.label}
            type={props.type}
            // style={style}
            onChange={props.change}
            value={props.value}
            onBlur={props.blur}
            className={
              "coach-input coach-new-input " +
              (withBorder ? 'with-border ' : '') +
              (props.hasError == "false" || !props.hasError ? "" : "error")
            }
            style={{ opacity: props.editable == "false" ? 0.5 : 1 }}
            disabled={props.editable == "false" ? true : false}
            {...props}
          />
          <div className="box-image">
            <img src={props.boxIcon} onClick={props.click} />
          </div>
        </div>
      )}
    </div>
  );
};

export default coachInputField;
